import React, {Component} from 'react';
import { connect } from 'react-redux';

import NavArrow from '../../shared/components/nav-arrow';
import { Carousel } from '../../shared/components/carousel';
import CarouselIndicator from '../../shared/components/carousel-indicator';
import { fetchProductGroups } from '../../utility/actions';

import '../css/product-carousel.less';

class ProductCarousel extends Component {

  state = {
    productSkus: [],
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let { skus } = this.props;

    //if it's an array of at least on object, assume we are done
    if(Array.isArray(skus) && typeof skus[0] === 'object'){
        this.setState({
        productSkus: skus,
      });
    }
    else{
      //otherwise get keyId as array of strings and request from api
      let skusId =  Array.isArray(skus) ? skus : Object.keys(skus);
      if(skusId.length > 0) {
        this.props.fetchProductGroups(skusId).then((response) => {

          //If skus is an array, make sure to put response back in sorted order
          if(Array.isArray(skus)) {

            let productSkus = response.sort((p1, p2) => skus.indexOf(p1.sku) - skus.indexOf(p2.sku));

            this.setState({
              productSkus,
            })

          }
          else {
            this.setState({
              productSkus: response,
            })
          }

        });
      }

    }

  }

   getProductSkus = (productSkus) => {
      const {render:productCarouselCard} = this.props;

      return(
            productSkus.map((product, i)=>(
                 productCarouselCard(`xsell-${i}`, product)
            ))
        )
    }

    getXSellSettings = (productSkusLength) => {

      return {
          slidesToShow: Math.min(productSkusLength, 3),
          slidesToScroll: 1,
          ...this.controls(),
        }
    }

    getXSellMobileSettings = () => {

      return {
        slidesToShow: 1,
        slidesToScroll: 1,
        ...this.controls(),
      }

    }

    controls = () => {
      // width and customBreakpoints are avaialable if using ResponsiveProductCarousel
      let {renderBottomCenterControls=false, getSlideConfig, width, customBreakpoints} = this.props;
      let {productSkus} = this.state;
      let slideConfig = typeof getSlideConfig === 'function' ? getSlideConfig({ productSkus, width, customBreakpoints}): {};
      let {customSlideCount} = slideConfig || {};
      let bottomControlComponent = renderBottomCenterControls 
                                    ? (props) => <CarouselIndicator {...props} customSlideCount={customSlideCount} /> 
                                    : null;
      let rightControlComponent  = getSlideConfig 
                                    ? (props) => <NavArrow.NextArrow {...props} customSlideCount={customSlideCount} />
                                    : NavArrow.NextArrow
      return {
          renderCenterLeftControls : NavArrow.PrevArrow,
          renderCenterRightControls: rightControlComponent,
          renderBottomCenterControls: bottomControlComponent,
      }
    }

  render() {
    const { productSkus } = this.state;
    const productSkusLength = productSkus.length;
    // customBreakpoints is only available when using ResponsiveProductCarousel
    let {slideWidth, initialSlideHeight, className, getClassName, wrapperClassName, getSlideConfig, header, customBreakpoints, slidesToShow} = this.props;
    let carouselProps = {
      slideWidth,
      initialSlideHeight
    };

    let slideConfig = typeof getSlideConfig === 'function'
                      ? getSlideConfig({productSkus, customBreakpoints})
                      : {};
    const carouselStyle = productSkusLength === 1 ? {width: '400px', margin: 'auto'} : {};
    let customClassNames = typeof getClassName === 'function' ? getClassName({productSkus, customBreakpoints}) : null; 

    let headerComponent = header && <h2 className="carousel-header">{header}</h2>;
    return (
      <div className={`product-carousel-container${wrapperClassName ? ' ' + wrapperClassName : ''}${customClassNames ? ' ' + customClassNames : ''}`}>
    { productSkus.length > 0 ? (
      <div>
        <div className='product-carousel-desktop-component'>
          {headerComponent}
          {
              <Carousel {...carouselProps} renderBottomCenterControls={false} style={carouselStyle} id='product-carousel-richtext' className={`product-carousel-richtext${className ?' '+ className : ''}${customClassNames ? ' ' + customClassNames : ''}`} {...this.getXSellSettings(productSkusLength)} {...slideConfig || {}} ref={carousel=> carousel = carousel}>
                {
                  this.getProductSkus(productSkus)
                }
              </Carousel>
          }
      </div>
      <div className='product-carousel-mobile-component'>
          {headerComponent}
          {
              <Carousel {...carouselProps} renderBottomCenterControls={false} id='product-carousel-richtext' className={`product-carousel-richtext${className ?' '+ className : ''}${customClassNames ? ' ' + customClassNames : ''}`} {...this.getXSellMobileSettings()} {...slideConfig || {}} ref={carousel=> carousel = carousel}>
                {
                  this.getProductSkus(productSkus)
                }
              </Carousel>
          }
      </div>
      </div> ) : null
    }
    </div>
    );

  }

}

const mapDispatchToProps = dispatch => ({
    fetchProductGroups: (skus) => dispatch(fetchProductGroups(skus)),
});

export default connect(
    null,
    mapDispatchToProps,
)(ProductCarousel);
